// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import css from './items.css'
type ThumbableServicesProps = {
  data: Array<string>
  emptyText: string
}

const ThumbableServices = ({ data, emptyText }: ThumbableServicesProps) => (
  <div className={css.component}>
    <div className={css.itemList}>
      {data.length > 0 ? (
        <table className={css.table} cellPadding={0} cellSpacing={0}>
          <tbody className={css.isList}>
            {data.map((value, i) => (
              <tr key={i}>
                <td>{value.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className={css.emptyText}>{emptyText}</p>
      )}
    </div>
  </div>
)

export default ThumbableServices
